<template>
  <div>
    <i-head-top></i-head-top>
    <div style="height: 100px;" v-if="isFixed && !hideSearchBanner"></div>
    <div v-if="!hideSearchBanner" class="h-banner-box" id="h-banner"
         :style="fixedStyle" :class="{isFixed:isFixed}">
      <div class="container fc">
        <router-link to="index" class="logo fc" >
          <img src="../assets/logo-shop.png" alt="" srcset="" width="184" @click="toIndexFun">
        </router-link>
        <div class="search">
          <div class="search-text flex">
            <input type="text" class="search-ipt" placeholder="" v-model="searchValue"
                   @focus="showSearchPanel = true" @blur="handleSearchBlur" v-on:keyup.enter="searchEnter" >
            <a href="javascript:void(0);"  class="search-top-btn fcc" @click="searchEnter">
              <img src="../assets/search-btn.png" alt="">
            </a>
          </div>
          <div class="search-suggest" v-show="showSearchPanel" @mousedown.prevent>
            <div class="suggest-block" v-if="historyKeywords.length">
              <div class="suggest-head">
                <span>历史搜索</span>
                <a href="javascript:void(0);" class="clear-history" @click="clearHistory">全部清除</a>
              </div>
              <div class="suggest-tags">
                <a href="javascript:void(0);" class="suggest-tag"
                   v-for="(item,index) in historyKeywords" :key="'history-'+index"
                   @click="applyKeyword(item)">{{ item }}</a>
              </div>
            </div>
            <div class="suggest-block" v-if="hotKeywords.length">
              <div class="suggest-head">
                <span>热门搜索</span>
              </div>
              <div class="suggest-tags">
                <a href="javascript:void(0);" class="suggest-tag"
                   v-for="(item,index) in hotKeywords" :key="'hot-'+index"
                   @click="applyKeyword(item)">{{ item }}</a>
              </div>
            </div>
            <div class="suggest-empty" v-if="!historyKeywords.length && !hotKeywords.length">暂无搜索记录</div>
          </div>
        </div>
        <div class="h-top-right">
          <div class="top-right-top fc">
            <div v-if="!isIntegralUser" class="head-car-box pr">
              <router-link to="cart" class="btn-car fcc">
                <img src="../assets/cart-icon.png" width="24" height="24" alt="">
                <span>购物车</span>
                <span class="cart-count">{{ cartNum }}</span>
              </router-link>
              <div class="head-mini-car-box">
                <div class="mini-car-items">
                  <div class="mini-car-item flex" v-for="(item,index) in cartList" :key="index">
                    <!--                    <router-link to="details" class="img">-->
                    <router-link :to="{path:'/details',query:{unique:item.productInfo.attrInfo.unique}}" class="img">
<!--                      <router-link :to="{path:'details',query:{unique:item.productInfo.attrInfo.unique}}">-->
                      <img :src="item.productInfo.image" v-if="item.productInfo.image" alt="">
                      <img :src="item.image" v-else alt="">
                    </router-link>
                    <div class="content flex1">
                      <div class="name-row fc-bet">
                        <router-link :to="{path:'/details',query:{unique:item.productInfo.attrInfo.unique}}" class="name">
<!--                        <router-link to="details" class="name">-->
                          <!--													D247V c型 2p 16A-->
                          {{ item.productInfo.storeName }}
                        </router-link>
                        <em class="el-icon-error" @click="delCart(item.id)"></em>
                      </div>
                      <div class="price-row fc-bet">
                        <span>数量：{{ item.cartNum }}</span>
                        <b>￥{{ (item.truePrice * item.cartNum).toFixed(2) }}</b>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="mini-car-total fc-bet">
                  <div class="fc left">
                    <span>共有<b>{{cartList.length}}</b>种商品</span>
                    <span>合计:<strong>￥{{ totalPrice.toFixed(2) }}</strong></span>
                  </div>
                  <router-link to="cart" class="btn-to-car fcc">
                    <span>查看购物车</span>
                  </router-link>
                </div>
              </div>
            </div>
            <router-link v-if="showPriceQueryBtn" to="/batch-search" class="btn-price-query fcc">
              <span>价格查询</span>
            </router-link>
            <!--						<a href="" class="btn-speed-order fcc">-->
            <!--							<i></i>-->
            <!--							<span>快速下单</span>-->
            <!--						</a>-->
          </div>
          <!--					<a href="" class="btn-save-desktop fcc">-->
          <!--						<img src="../assets/desktop.png" alt="">-->
          <!--						<span>添加到桌面</span>-->
          <!--					</a>-->
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import currentUser from '@/mixins/current-user'
import { getHotSearchProducts } from '@/api/indexpage'
import {queryCartList} from "@/api/home";
import {cartCount, cartDel, cartList} from '@/api/cart'
import {
  mapGetters,
  mapMutations
} from "vuex";
import { getToken } from '@/axios/cookies'
import { clearUserInfo, getStoredUserInfo, hasUserIdentity, saveUserInfo } from '@/utils/auth'
export default {
  mixins: [currentUser],
  name: 'login-after-head',
  data() {

    return {
      searchValue: '',
      queryParam: {},
      totalPrice: 0,
      catNum: 0,
      cartList: [],
      fixedStyle: "",
      isFixed: false,
      status: 0,
      showPriceQueryBtn: false,
      showSearchPanel: false,
      historyKeywords: [],
      hotKeywords: [],
    }
  },
  computed: {
    ...mapGetters({
      userInfo: 'userInfo', // 用户信息
      cartNum: 'cartNum' // 购物车商品数量
    }),
    hideSearchBanner () {
      return this.isIntegralUser && this.$route.path === '/score'
    }
  },
  methods: {
    toIndexFun(){
      sessionStorage.removeItem("searchValueSession");
      this.searchValue=""
    },
    searchEnter() {
      this.doSearch(this.searchValue)
    },
    doSearch(keyword) {
      const kw = (keyword || '').trim()
      if (!kw) return
      this.searchValue = kw
      this.saveHistory(kw)
      this.showSearchPanel = false
      sessionStorage.setItem("searchValueSession", kw)
      this.$router.push('/list?searchValue=' + encodeURIComponent(kw))
    },
    applyKeyword(keyword) {
      this.doSearch(keyword)
    },
    handleSearchBlur() {
      setTimeout(() => {
        this.showSearchPanel = false
      }, 150)
    },
    loadHistory() {
      try {
        const list = JSON.parse(localStorage.getItem('searchHistory') || '[]')
        this.historyKeywords = Array.isArray(list)
          ? list.filter(item => typeof item === 'string' && item)
          : []
      } catch (e) {
        this.historyKeywords = []
      }
    },
    saveHistory(keyword) {
      const list = this.historyKeywords.filter(item => item !== keyword)
      list.unshift(keyword)
      this.historyKeywords = list.slice(0, 10)
      localStorage.setItem('searchHistory', JSON.stringify(this.historyKeywords))
    },
    clearHistory() {
      this.historyKeywords = []
      localStorage.removeItem('searchHistory')
    },
    loadHotKeywords() {
      getHotSearchProducts().then(res => {
        const list = (res && Array.isArray(res.data)) ? res.data : []
        this.hotKeywords = list
          .map(item => item && item.storeName)
          .filter(Boolean)
      }).catch(() => {})
    },
    queryCartListFun() {
      queryCartList(this.queryParam).then(res => {
        console.log('购物车查询', res)
        this.cartList = res.storeCarts
        this.calculationPrice()
      })
    },
    calculationPrice() {
      this.totalPrice = 0
      this.cartList.forEach(i => {
        this.totalPrice += i.cartNum * Number(i.productInfo.attrInfo.price)
        this.catNum += i.cartNum
      })
    },
    handleScroll() {
      if (this.hideSearchBanner) {
        this.isFixed = false
        return
      }
      let top = Math.floor(document.documentElement.scrollTop || document.body.scrollTop);
      if (top > 30) {
        this.isFixed = true
      } else {
        this.isFixed = false
      }
    },
    // 获取购物车列表
    async getCartList () {
      const res = await cartList()
      if (res.status === 200) {
        this.cartList = res.data.valid
        this.calculationPrice()
      } else {
        this.$message.warning(res.msg)
      }
    },
    // 删除购物车商品
    delCart (id) {
      let ids = []
      ids.push(id)
      this.del(ids)
    },
    // 删除请求
    del (ids) {
      console.log('删除购物车产品', ids)
      cartDel({ 'ids': ids }).then(res => {
        if (res.status === 200) {
          this.$message.success('删除成功')
          this.getCartList()
          this.getCartNum()
        } else {
          this.$message.warning(res.msg)
        }
      })
    },
    ...mapMutations({
      setCartNum: 'SET_CARTNUM' // 修改vuex购物车数量
    }),
    // 获取购物车商品数量
    async getCartNum () {
      const res = await cartCount()
      if (res.status === 200) {
        this.setCartNum(res.data.count)
      } else {
        this.$message.warning(res.msg)
      }
    },
    isLogin () {
      const token = getToken()
      const userInfo = this.userInfo && hasUserIdentity(this.userInfo)
        ? this.userInfo
        : getStoredUserInfo()
      this.status = token && hasUserIdentity(userInfo) ? 1 : 0
      if (this.status) {
        saveUserInfo(userInfo)
        this.showPriceQueryBtn = Boolean(userInfo.name)
        if (!this.isIntegralUser) {
          this.getCartList()
          this.getCartNum()
        }
      } else {
        clearUserInfo()
        this.showPriceQueryBtn = false
        this.cartList = []
        this.setCartNum(0)
      }
    }
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.handleScroll)
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
    this.loadHistory()
    this.loadHotKeywords()
    this.isLogin()
    
    // if (this.status && this.status===1){
    //   this.getCartList()
    //   this.getCartNum()
    // }
    const searchValueSession = sessionStorage.getItem("searchValueSession");
    if (searchValueSession){
      this.searchValue = searchValueSession
    }
  }

}
</script>

<style scoped="scoped" lang="less">
#h-banner.isFixed {
  position: fixed;
  top: 0px;
  box-shadow: rgba(0, 0, 0, 0.3) 2px 2px 7px;
  z-index: 1000
}

.btn-price-query {
  min-width: 88px;
  height: 40px;
  margin-left: 10px;
  padding: 0 12px;
  border: 1px solid #57aca7;
  border-radius: 2px;
  color: #57aca7;
  font-size: 14px;
  background: #fff;
}

.search {
  position: relative;
}

.search-suggest {
  position: absolute;
  top: 44px;
  left: 0;
  width: 628px;
  padding: 18px 18px 8px;
  box-sizing: border-box;
  max-height: 420px;
  overflow-y: auto;
  background: #fff;
  border: 1px solid #e5e5e5;
  border-radius: 4px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  z-index: 1200;
}

.suggest-block + .suggest-block {
  margin-top: 18px;
}

.suggest-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
  font-size: 15px;
  color: #333;
}

.clear-history {
  color: #8a8a8a;
  font-size: 13px;
}

.clear-history:hover {
  color: #57aca7;
}

.suggest-tags {
  display: flex;
  flex-wrap: wrap;
}

.suggest-tag {
  display: inline-block;
  margin: 0 10px 10px 0;
  padding: 5px 10px;
  background: #f2f2f2;
  border-radius: 2px;
  color: #666;
  font-size: 13px;
  line-height: 20px;
  text-decoration: none;
  transition: all 0.2s;
}

.suggest-tag:hover {
  background: #57aca7;
  color: #fff;
}

.suggest-empty {
  padding: 10px 0 14px;
  color: #999;
  font-size: 13px;
  text-align: center;
}
</style>
